module.exports = __webpack_public_path__ + "Roboto-BoldItalic.355e388740673054493c.woff2";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/roboto-fontface/fonts/roboto/Roboto-BoldItalic.woff2
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-BoldItalic.woff2
// module chunks = styles